import { appConstants } from '../_constants';
import { initialState } from '../_helpers';

export function api(state=initialState.api, action) {
    switch (action.type) {
        case appConstants.API_REQUEST_FULL_PAGE_START:
            return Object.assign({}, state, {requesting: false, pageRequesting: true});
        case appConstants.API_REQUEST_START:
            return Object.assign({}, state, {requesting: true, pageRequesting: false});
        case appConstants.API_REQUEST_FINISH:
            return Object.assign({}, state, {requesting: false, pageRequesting: false});
        case appConstants.REQUEST_SUCCESS:
            return Object.assign({}, state, {requesting: false, pageRequesting: false});
        case appConstants.REQUEST_FAILURE:
            return Object.assign({}, state, {requesting: false, pageRequesting: false});
        default:
          return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/api.reducer.js